export default "__VITE_ASSET__3835e840__"